module.exports = __webpack_public_path__ + "img/icon-advantage-3.d1131e71.png";